export const EvaluationSkillPhase = {
    path: '/evaluation_skill_phases',
    name: 'evaluation_skill_phases',
    component: () => import('@/views/Evaluation/Phase/EvaluationSkillPhasePage.vue'),
    props: {type: 'EVALUATION_SKILL'},
    children: [
        {
            path: '/evaluation_skill_phases/add',
            name: 'evaluation_skill_phases.add',
            component: () => import('@/views/Evaluation/Phase/Form/EvaluationPhaseForm.vue'),
            props: {addAction: true, type: 'EVALUATION_SKILL'}
        },
        {
            path: '/evaluation_skill_phases/edit/:id',
            name: 'evaluation_skill_phases.edit',
            component: () => import('@/views/Evaluation/Phase/Form/EvaluationPhaseForm.vue'),
            props: {updateAction: true, type: 'EVALUATION_SKILL'}
        },
        {
            path: '/evaluation_skill_phases/delete/:id',
            name: 'evaluation_skill_phases.delete',
            component: () => import('@/views/Evaluation/Phase/Form/EvaluationPhaseForm.vue'),
            props: {deleteAction: true, type: 'EVALUATION_SKILL'}
        },
        {
            path: '/evaluation_skill_phases/view/:id',
            name: 'evaluation_skill_phases.view',
            component: () => import('@/views/Evaluation/Phase/Form/EvaluationPhaseForm.vue'),
            props: {viewAction: true, type: 'EVALUATION_SKILL'}
        },
    ]
}